import "./pagination.scss";
import "../../../styles/fontSizes.scss";
import Text from "componets/atoms/text/text";
import ArrowButton from "componets/atoms/arrowButton/arrowButton";

const Pagination = ({ textSize, numberOfPages, setPage, page }) => {
  var pages = [];
  function handleChangePage(value) {
    if (value <= numberOfPages && value >= 1) setPage(value);
  }
  for (let i = 1; i <= numberOfPages; i++) {
    pages.push(
      <div key={i}>
        <input
          checked={i == page}
          id={`pagination__${i}`}
          className="pagination__page-number"
          type="radio"
          name="pagination__numbers"
          onClick={(e) => handleChangePage(e.target.value)}
          value={i}
          key={i}
          readOnly
        />
        <label
          htmlFor={`pagination__${i}`}
          className="pagination__page-label font-size--1"
        >
          {i}
        </label>
      </div>
    );
  }
  return (
    <div className="pagination__container">
      <ArrowButton
        type="left"
        textSize={1}
        handleClick={() => handleChangePage(page - 1)}
      ></ArrowButton>
      <Text type="p" textSize={textSize}>
        Anterior
      </Text>
      {pages}
      <Text type="p" textSize={textSize}>
        Siguiente
      </Text>
      <ArrowButton
        type="right"
        textSize={1}
        handleClick={() => handleChangePage(page + 1)}
      ></ArrowButton>
    </div>
  );
};

export default Pagination;
